import { Link } from "gatsby"
import styled from "styled-components"
import { COLORS } from "../../utils/page"

export const ReadLink = styled(Link)`
  /*  display: inline-block; */
  font-size: 0.875rem;
  color: ${COLORS.default};
  text-decoration: none;
  :hover {
    text-decoration: none;
    color: black;
    cursor: pointer;
  }
`

export default ReadLink
